/**
 * v15
 * Add terminals table
 */

export const schemaV15 = {
    taxes: 'id, name, value, deleted, [id+deleted]',
    paymentMethods:
        'id, name, type, deleted, enabled, [id+deleted], [enabled+deleted]',
    staff: 'id, authUserId, role, deleted, registerPin, [registerPin+deleted], [id+deleted]',

    items: 'id, name, itemType, categoryId, measurementUnitId, isActive, [id+isActive], nameLower, *searchTokens',
    itemVariants:
        'id, name, sku, barcode, itemPriceType, itemId, deleted, [id+deleted], [itemId+deleted], [sku+deleted], [barcode+deleted]',

    itemVariantCompositions:
        'id, variantId, deleted, [id+deleted], parentVariantId, [parentVariantId+deleted]',

    categories: 'id, name, deleted, [id+deleted]',
    measurementUnits: 'id, name, deleted, [id+deleted]',

    discounts: 'id, hasRules, deleted, *customerGroupIds, [hasRules+deleted]',

    carts: 'id, dateAdded',
    terminals: 'serialNumber',
};
